import React from 'react';
import { GridLoader } from 'react-spinners';
import styled from "styled-components";

interface ILoadingOverlayProps {
  loadingText?: string
}

const LoadingOverlay: React.FC<ILoadingOverlayProps> = ({ loadingText = '' }) => (
    <LoadingOverlayContainer>
        <LoaderContainer>
            <LoaderGridContainer>
                <GridLoader size={15} color={'white'}/>
            </LoaderGridContainer>
            { loadingText }
        </LoaderContainer>
    </LoadingOverlayContainer>
);

const LoadingOverlayContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10000;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: black;
  opacity: 0.75;
`;

const LoaderContainer = styled.div`
  position: absolute;
  left: 0;
  top: calc(50% - 30px);
  width: 100%;
  font-weight: bold;
  font-size: 24px;
  text-align: center;
  color: white;
  transition: top, left 0.2s ease;
`;

const LoaderGridContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
`

export default LoadingOverlay;
